import React from 'react';
import { TrendingUp, Clock, DollarSign } from 'lucide-react';

const CaseStudies = () => {
  const caseStudies = [
    {
      industry: "Manufacturing",
      challenge: "Manual quality control processes causing production delays",
      solution: "Implemented AI-powered visual inspection system with automated defect detection",
      results: {
        efficiency: "75% faster quality checks",
        cost: "$180K annual savings",
        productivity: "40% increase in output"
      },
      image: "https://images.unsplash.com/photo-1717386255767-52643970d483?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwyfHxidXNpbmVzcyUyMGF1dG9tYXRpb258ZW58MHx8fHwxNzc0MDgzMjEzfDA&ixlib=rb-4.1.0&q=85"
    },
    {
      industry: "E-commerce Retail",
      challenge: "Overwhelmed customer service team handling repetitive inquiries",
      solution: "Deployed intelligent chatbot with natural language processing for customer support",
      results: {
        efficiency: "80% of queries resolved automatically",
        cost: "$95K saved in support costs",
        productivity: "24/7 customer support coverage"
      },
      image: "https://images.pexels.com/photos/3183131/pexels-photo-3183131.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
    },
    {
      industry: "Financial Services",
      challenge: "Time-consuming invoice processing and reconciliation",
      solution: "Automated invoice extraction, validation, and payment processing system",
      results: {
        efficiency: "90% reduction in processing time",
        cost: "$125K annual cost reduction",
        productivity: "99.8% accuracy rate"
      },
      image: "https://images.pexels.com/photos/6266455/pexels-photo-6266455.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
    },
    {
      industry: "Healthcare Administration",
      challenge: "Manual patient appointment scheduling causing errors and no-shows",
      solution: "AI-driven scheduling system with automated reminders and intelligent booking",
      results: {
        efficiency: "60% reduction in no-shows",
        cost: "$85K recovered revenue",
        productivity: "50% less admin time spent"
      },
      image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwyfHxkYXRhJTIwYW5hbHlzaXN8ZW58MHx8fHwxNzc0MDgzMjI0fDA&ixlib=rb-4.1.0&q=85"
    },
    {
      industry: "Logistics & Distribution",
      challenge: "Inefficient route planning leading to high fuel costs",
      solution: "Machine learning-based route optimization with real-time traffic analysis",
      results: {
        efficiency: "35% reduction in delivery time",
        cost: "$210K annual fuel savings",
        productivity: "25% more deliveries per day"
      },
      image: "https://images.unsplash.com/photo-1716191300006-ea66bf47e2b9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHw0fHxidXNpbmVzcyUyMGF1dG9tYXRpb258ZW58MHx8fHwxNzc0MDgzMjEzfDA&ixlib=rb-4.1.0&q=85"
    },
    {
      industry: "Marketing Agency",
      challenge: "Manual social media reporting consuming 15 hours weekly",
      solution: "Automated data aggregation and reporting dashboard with AI insights",
      results: {
        efficiency: "95% time saved on reports",
        cost: "$65K in recovered billable hours",
        productivity: "Real-time analytics access"
      },
      image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwyfHxkYXRhJTIwYW5hbHlzaXN8ZW58MHx8fHwxNzc0MDgzMjI0fDA&ixlib=rb-4.1.0&q=85"
    },
    {
      industry: "Legal Services",
      challenge: "Document review and contract analysis bottlenecks",
      solution: "AI-powered document analysis with clause extraction and risk flagging",
      results: {
        efficiency: "70% faster document review",
        cost: "$150K in efficiency gains",
        productivity: "3x more contracts processed"
      },
      image: "https://images.pexels.com/photos/3183131/pexels-photo-3183131.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
    },
    {
      industry: "Food & Beverage",
      challenge: "Inventory management causing waste and stockouts",
      solution: "Predictive inventory system with demand forecasting and auto-reordering",
      results: {
        efficiency: "45% reduction in waste",
        cost: "$98K saved in inventory costs",
        productivity: "Zero stockouts achieved"
      },
      image: "https://images.unsplash.com/photo-1717386255767-52643970d483?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwyfHxidXNpbmVzcyUyMGF1dG9tYXRpb258ZW58MHx8fHwxNzc0MDgzMjEzfDA&ixlib=rb-4.1.0&q=85"
    },
    {
      industry: "Real Estate",
      challenge: "Lead qualification and follow-up taking too much time",
      solution: "AI agent for lead scoring, automated follow-ups, and appointment booking",
      results: {
        efficiency: "80% of leads qualified automatically",
        cost: "$75K in increased conversions",
        productivity: "5x faster response time"
      },
      image: "https://images.pexels.com/photos/6266455/pexels-photo-6266455.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
    },
    {
      industry: "Professional Services",
      challenge: "Time tracking and billing inconsistencies affecting revenue",
      solution: "Automated time capture with AI categorization and instant invoicing",
      results: {
        efficiency: "100% billable time captured",
        cost: "$120K in recovered revenue",
        productivity: "70% faster invoicing"
      },
      image: "https://images.unsplash.com/photo-1716191300006-ea66bf47e2b9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHw0fHxidXNpbmVzcyUyMGF1dG9tYXRpb258ZW58MHx8fHwxNzc0MDgzMjEzfDA&ixlib=rb-4.1.0&q=85"
    }
  ];

  return (
    <div className="page-container">
      {/* Hero Section */}
      <section className="case-studies-hero">
        <div className="case-studies-hero-content">
          <h1 className="page-title">
            Real Results from <span className="text-accent">Real Businesses</span>
          </h1>
          <p className="page-subtitle">
            Discover how companies like yours have transformed their operations and achieved remarkable growth with our AI-powered automation solutions.
          </p>
        </div>
      </section>

      {/* Case Studies Grid */}
      <section className="case-studies-grid-section">
        <div className="case-studies-grid">
          {caseStudies.map((study, index) => (
            <div key={index} className="case-study-card">
              <div className="case-study-image-wrapper">
                <img 
                  src={study.image} 
                  alt={study.industry}
                  className="case-study-image"
                />
                <div className="case-study-industry-tag">
                  {study.industry}
                </div>
              </div>
              
              <div className="case-study-content">
                <div className="case-study-section">
                  <h3 className="case-study-heading">Challenge</h3>
                  <p className="case-study-text">{study.challenge}</p>
                </div>

                <div className="case-study-section">
                  <h3 className="case-study-heading">Solution</h3>
                  <p className="case-study-text">{study.solution}</p>
                </div>

                <div className="case-study-results">
                  <h3 className="case-study-heading">Results</h3>
                  <div className="results-grid">
                    <div className="result-item">
                      <Clock className="result-icon" />
                      <p className="result-value">{study.results.efficiency}</p>
                    </div>
                    <div className="result-item">
                      <DollarSign className="result-icon" />
                      <p className="result-value">{study.results.cost}</p>
                    </div>
                    <div className="result-item">
                      <TrendingUp className="result-icon" />
                      <p className="result-value">{study.results.productivity}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* CTA Section */}
      <section className="case-studies-cta-section">
        <div className="case-studies-cta-content">
          <h2 className="case-studies-cta-title">Ready to Write Your Success Story?</h2>
          <p className="case-studies-cta-subtitle">
            Join these businesses in transforming their operations. Let's discuss how we can help you achieve similar results.
          </p>
          <a href="/contact" className="btn-primary">
            Schedule Free Consultation
          </a>
        </div>
      </section>
    </div>
  );
};

export default CaseStudies;
